import { Combobox } from '@mantine/core'

import CarrierOptionBody from './CarrierOptionBody'
import { CarrierOptionCompany } from './carrierOptionDetails'

interface CompanyOptionProps {
  company: CarrierOptionCompany
  index: number
}

const CompanyOption = ({ company, index }: CompanyOptionProps) => (
  <Combobox.Option
    className="flex items-start gap-3 py-1.5"
    value={company}
    key={`${company.dotNumber}-${company.companyName}-${index}`}
  >
    <CarrierOptionBody company={company} />
  </Combobox.Option>
)

export default CompanyOption
